/* GND custom: cart drawer dynamic recommendations
 * - Section Rendering API refresh on cart change
 * - sessionStorage cache keyed by cart fingerprint
 * - Native /recommendations/products.json fallback when rule engine returns 0
 * - Static admin-set fallback (template tag) as last resort
 */
(function () {
  'use strict';

  var SECTION_ID = 'gnd-cart-recommendations';
  var SECTION_HOST_SELECTOR = '#shopify-section-' + SECTION_ID;
  var ROOT_SELECTOR = '[data-gnd-cart-recommendations]';
  var SLIDER_SELECTOR = '[data-gnd-cart-recommendations-slider]';
  var STATIC_FALLBACK_SELECTOR = '[data-gnd-cart-recommendations-static-fallback]';
  var CACHE_KEY = 'gnd_cart_reco_cache_v1';
  var CACHE_FP_KEY = 'gnd_cart_reco_fp_v1';

  function dlog() {
    if (window.location.href.indexOf('preview_theme_id') === -1) return;
    try { console.log.apply(console, ['[GND cart-reco]'].concat([].slice.call(arguments))); } catch (e) {}
  }

  function fingerprint(cart) {
    if (!cart || !cart.items) return '';
    return cart.items
      .map(function (i) { return i.product_id + ':' + i.quantity; })
      .sort()
      .join('|');
  }

  function seededShuffle(arr, seedStr) {
    var seed = 0;
    for (var i = 0; i < seedStr.length; i++) {
      seed = ((seed * 31) + seedStr.charCodeAt(i)) >>> 0;
    }
    var shuffled = arr.slice();
    for (var i = shuffled.length - 1; i > 0; i--) {
      seed = ((seed * 1103515245) + 12345) >>> 0;
      var j = seed % (i + 1);
      var tmp = shuffled[i];
      shuffled[i] = shuffled[j];
      shuffled[j] = tmp;
    }
    return shuffled;
  }

  function applyDiversityShuffle(root, cart) {
    if (!root || !cart) return;
    var slider = root.querySelector(SLIDER_SELECTOR);
    if (!slider) return;
    var allCards = Array.prototype.slice.call(
      slider.querySelectorAll('[data-gnd-cart-recommendation-card]')
    );
    var visibleInitial = parseInt(slider.getAttribute('data-gnd-visible-initial'), 10) || 3;
    if (allCards.length <= visibleInitial) return;
    var fp = fingerprint(cart);
    if (!fp) return;
    var indices = [];
    for (var i = 0; i < allCards.length; i++) indices.push(i);
    var picks = seededShuffle(indices, fp).slice(0, visibleInitial);
    allCards.forEach(function (c) { c.classList.add('gnd-cart-recommendations__card--hidden'); });
    picks.forEach(function (i) {
      allCards[i].classList.remove('gnd-cart-recommendations__card--hidden');
      slider.appendChild(allCards[i]);
    });
  }

  function fetchCart() {
    return fetch('/cart.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .catch(function () { return null; });
  }

  function fetchSection() {
    return fetch('/?section_id=' + SECTION_ID, { credentials: 'same-origin' })
      .then(function (r) { return r.text(); })
      .catch(function () { return null; });
  }

  function swapSection(html) {
    if (!html) return null;
    var host = document.querySelector(SECTION_HOST_SELECTOR);
    if (!host) return null;
    host.innerHTML = html;
    return host.querySelector(ROOT_SELECTOR);
  }

  function readCache(fp) {
    try {
      if (sessionStorage.getItem(CACHE_FP_KEY) !== fp) return null;
      return sessionStorage.getItem(CACHE_KEY);
    } catch (e) { return null; }
  }

  function writeCache(fp, html) {
    try {
      sessionStorage.setItem(CACHE_FP_KEY, fp);
      sessionStorage.setItem(CACHE_KEY, html);
    } catch (e) {}
  }

  function clearCache() {
    try {
      sessionStorage.removeItem(CACHE_KEY);
      sessionStorage.removeItem(CACHE_FP_KEY);
    } catch (e) {}
  }

  function renderNativeFallback(products, root) {
    if (!products || !products.length || !root) return false;
    var heading = root.querySelector('.gnd-cart-recommendations__heading');
    var headingText = heading ? heading.textContent.trim() : '';
    if (!headingText) {
      var headingEl = document.querySelector('[data-gnd-cart-recommendations-heading-text]');
      headingText = headingEl ? headingEl.textContent.trim() : '';
    }

    var slider = document.createElement('div');
    slider.className = 'gnd-cart-recommendations__slider';
    slider.setAttribute('data-gnd-cart-recommendations-slider', '');

    products.slice(0, 3).forEach(function (p) {
      if (!p.available) return;
      var card = document.createElement('article');
      card.className = 'gnd-cart-recommendations__card';
      card.setAttribute('data-gnd-cart-recommendation-card', '');
      card.setAttribute('data-product-id', p.id);

      var imgUrl = (p.featured_image || p.images && p.images[0] || '').toString();
      var price = (p.price / 100).toFixed(2);
      var currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || '';

      card.innerHTML =
        '<a class="gnd-cart-recommendations__card-image" href="' + p.url + '" tabindex="-1" aria-hidden="true">' +
          (imgUrl ? '<img src="' + imgUrl + '" alt="" loading="lazy">' : '') +
        '</a>' +
        '<div class="gnd-cart-recommendations__card-body">' +
          '<a class="gnd-cart-recommendations__card-title" href="' + p.url + '">' + escapeHtml(p.title) + '</a>' +
          '<div class="gnd-cart-recommendations__card-price">' + price + ' ' + currency + '</div>' +
          '<a class="gnd-cart-recommendations__card-add button button--small button--outline--hover-accent" href="' + p.url + '"><span class="button__text">→</span></a>' +
        '</div>';

      slider.appendChild(card);
    });

    if (!slider.children.length) return false;

    var existingSlider = root.querySelector(SLIDER_SELECTOR);
    if (existingSlider) {
      existingSlider.replaceWith(slider);
    } else {
      // No heading rendered (rule engine returned 0); inject heading + slider
      var h = document.createElement('div');
      h.className = 'gnd-cart-recommendations__heading';
      h.textContent = headingText || '';
      root.appendChild(h);
      root.appendChild(slider);
    }
    root.setAttribute('data-gnd-picked-count', String(slider.children.length));
    root.setAttribute('data-gnd-needs-fallback', 'false');
    return true;
  }

  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function tryNativeFallback(root, cart) {
    if (!cart || !cart.items || !cart.items.length) return Promise.resolve(false);
    var firstId = cart.items[0].product_id;
    return fetch('/recommendations/products.json?product_id=' + firstId + '&limit=3&intent=related', {
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json' }
    })
      .then(function (r) { return r.json(); })
      .then(function (json) {
        var products = (json && json.products) || [];
        // Exclude cart items
        var cartIds = {};
        cart.items.forEach(function (i) { cartIds[i.product_id] = true; });
        products = products.filter(function (p) { return !cartIds[p.id]; });
        return renderNativeFallback(products, root);
      })
      .catch(function () { return false; });
  }

  function tryStaticFallback(root) {
    var tpl = root.querySelector(STATIC_FALLBACK_SELECTOR);
    if (!tpl || !tpl.content) return false;
    // Clear root and append the template content
    var clone = tpl.content.cloneNode(true);
    // Don't clear the template itself; just append the clone above it
    root.insertBefore(clone, tpl);
    root.setAttribute('data-gnd-picked-count', '1');
    root.setAttribute('data-gnd-needs-fallback', 'false');
    return true;
  }

  function ensureFallbackChain(root, cart) {
    if (!root) return Promise.resolve();
    if (root.getAttribute('data-gnd-needs-fallback') !== 'true') return Promise.resolve();
    dlog('rule engine returned 0; trying native fallback');
    return tryNativeFallback(root, cart).then(function (ok) {
      if (ok) { dlog('native fallback rendered'); return; }
      dlog('native fallback empty; trying static fallback');
      var staticOk = tryStaticFallback(root);
      if (staticOk) { dlog('static fallback rendered'); return; }
      dlog('all fallbacks empty — module hidden');
    });
  }

  function refresh(opts) {
    opts = opts || {};
    var force = !!opts.force;
    return fetchCart().then(function (cart) {
      if (!cart) return;
      var fp = fingerprint(cart);

      var cached = !force && readCache(fp);
      if (cached) {
        dlog('cache hit', fp);
        var root = swapSection(cached);
        applyDiversityShuffle(root, cart);
        return ensureFallbackChain(root, cart);
      }

      return fetchSection().then(function (html) {
        if (!html) return;
        writeCache(fp, html);
        var root = swapSection(html);
        applyDiversityShuffle(root, cart);
        return ensureFallbackChain(root, cart);
      });
    });
  }

  function watchCartForm() {
    var cartForm = document.querySelector('.cart-form');
    if (!cartForm) return;
    var observer = new MutationObserver(function () {
      // cart-form mutates whenever Borders re-renders the cart fragment
      refresh({ force: true });
    });
    observer.observe(cartForm, { childList: true, subtree: true });
  }

  // ---- Inline quick-add (no PDP modal) -------------------------------------

  function refreshBordersCart() {
    // Mirror Borders' helper-cart fragment swap (assets/component-product-form.js)
    return fetch('?section_id=helper-cart', { credentials: 'same-origin' })
      .then(function (r) { return r.text(); })
      .then(function (text) {
        var doc = new DOMParser().parseFromString(text, 'text/html');
        var srcCart = doc.getElementById('AjaxCartForm');
        var srcSubtotal = doc.getElementById('AjaxCartSubtotal');
        var dstCart = document.getElementById('AjaxCartForm');
        var dstSubtotal = document.getElementById('AjaxCartSubtotal');
        if (srcCart && dstCart) {
          dstCart.innerHTML = srcCart.innerHTML;
          if (typeof dstCart.ajaxifyCartItems === 'function') {
            try { dstCart.ajaxifyCartItems(); } catch (e) {}
          }
        }
        if (srcSubtotal && dstSubtotal) {
          dstSubtotal.innerHTML = srcSubtotal.innerHTML;
        }
        var srcCount = doc.querySelector('#AjaxCartForm [data-cart-count]');
        var srcTotal = doc.querySelector('#AjaxCartForm [data-cart-total]');
        if (srcCount) {
          document.querySelectorAll('[data-header-cart-count]').forEach(function (elm) {
            elm.textContent = srcCount.textContent;
          });
        }
        if (srcTotal) {
          document.querySelectorAll('[data-header-cart-total]').forEach(function (elm) {
            elm.textContent = srcTotal.textContent;
          });
        }
        // Toggle empty state
        var sidebar = document.getElementById('site-cart-sidebar');
        if (sidebar) {
          var cartElm = document.getElementById('cart');
          if (cartElm && cartElm.classList.contains('cart--empty')) {
            sidebar.classList.add('cart-is-empty');
          } else {
            sidebar.classList.remove('cart-is-empty');
          }
          // Update item count attribute
          var headerCount = document.querySelector('[data-header-cart-count]');
          if (headerCount) sidebar.setAttribute('data-cart-items', headerCount.textContent.trim());
        }
      })
      .catch(function () {});
  }

  function openSidebarCart() {
    var sidebar = document.getElementById('site-cart-sidebar');
    if (!sidebar) return;
    if (typeof sidebar.show === 'function') {
      try { sidebar.show(); return; } catch (e) {}
    }
    // Fallback: dispatch the event Borders' sidebar listens for
    document.dispatchEvent(new CustomEvent('open-sidebar', { detail: { id: 'site-cart-sidebar' } }));
  }

  function setBtnState(btn, state, originalLabel) {
    if (!btn) return;
    var labelEl = btn.querySelector('[data-gnd-rec-add-label]') || btn.querySelector('.button__text') || btn;
    if (state === 'loading') {
      btn.setAttribute('data-busy', 'true');
      btn.disabled = true;
      labelEl.textContent = '...';
    } else if (state === 'success') {
      btn.removeAttribute('data-busy');
      labelEl.textContent = '✓';
      setTimeout(function () {
        if (originalLabel) labelEl.textContent = originalLabel;
        btn.disabled = false;
      }, 900);
    } else if (state === 'error') {
      btn.removeAttribute('data-busy');
      labelEl.textContent = '!';
      setTimeout(function () {
        if (originalLabel) labelEl.textContent = originalLabel;
        btn.disabled = false;
      }, 1400);
    } else {
      btn.removeAttribute('data-busy');
      btn.disabled = false;
      if (originalLabel) labelEl.textContent = originalLabel;
    }
  }

  function ajaxAddVariant(variantId, btn) {
    var labelEl = btn && (btn.querySelector('[data-gnd-rec-add-label]') || btn.querySelector('.button__text'));
    var origLabel = labelEl ? labelEl.textContent : '';
    setBtnState(btn, 'loading', origLabel);
    return fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('cart/add ' + r.status);
        return r.json();
      })
      .then(function () {
        setBtnState(btn, 'success', origLabel);
        return refreshBordersCart();
      })
      .then(function () {
        // Recommendations refresh is auto-triggered by the fetch patch in
        // watchAjaxAdd — no need to call refresh() here.
        document.dispatchEvent(new CustomEvent('cart:updated'));
        openSidebarCart();
      })
      .catch(function (e) {
        dlog('add error', e);
        setBtnState(btn, 'error', origLabel);
      });
  }

  function closeAllPickers(except) {
    document.querySelectorAll('[data-gnd-rec-picker]').forEach(function (p) {
      if (p === except) return;
      p.setAttribute('hidden', '');
    });
    document.querySelectorAll('[data-gnd-rec-toggle-picker]').forEach(function (b) {
      var card = b.closest('[data-gnd-cart-recommendation-card]');
      var picker = card && card.querySelector('[data-gnd-rec-picker]');
      if (picker !== except) b.setAttribute('aria-expanded', 'false');
    });
  }

  function bindCardInteractions() {
    if (window.__gndCartRecBound) return;
    window.__gndCartRecBound = true;

    // Single-variant: add button
    document.addEventListener('click', function (e) {
      var addBtn = e.target.closest('[data-gnd-rec-add]');
      if (!addBtn) return;
      // Stop modal triggers / any parent click handlers
      e.preventDefault();
      e.stopPropagation();
      if (addBtn.getAttribute('data-busy') === 'true') return;
      var vid = addBtn.getAttribute('data-variant-id');
      if (!vid) return;
      ajaxAddVariant(vid, addBtn);
    }, true);

    // Multi-variant: toggle picker
    document.addEventListener('click', function (e) {
      var toggle = e.target.closest('[data-gnd-rec-toggle-picker]');
      if (!toggle) return;
      e.preventDefault();
      e.stopPropagation();
      var card = toggle.closest('[data-gnd-cart-recommendation-card]');
      if (!card) return;
      var picker = card.querySelector('[data-gnd-rec-picker]');
      if (!picker) return;
      var isHidden = picker.hasAttribute('hidden');
      closeAllPickers(isHidden ? picker : null);
      if (isHidden) {
        picker.removeAttribute('hidden');
        toggle.setAttribute('aria-expanded', 'true');
      } else {
        picker.setAttribute('hidden', '');
        toggle.setAttribute('aria-expanded', 'false');
      }
    }, true);

    // Multi-variant: size button → add
    document.addEventListener('click', function (e) {
      var sizeBtn = e.target.closest('[data-gnd-rec-size]');
      if (!sizeBtn) return;
      e.preventDefault();
      e.stopPropagation();
      if (sizeBtn.disabled || sizeBtn.getAttribute('aria-disabled') === 'true') return;
      var vid = sizeBtn.getAttribute('data-variant-id');
      if (!vid) return;
      ajaxAddVariant(vid, sizeBtn);
    }, true);

    // Click outside picker → close
    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-gnd-rec-picker]')) return;
      if (e.target.closest('[data-gnd-rec-toggle-picker]')) return;
      closeAllPickers(null);
    });
  }

  function watchAjaxAdd() {
    // Listen for the standard Borders / Shopify cart change events
    document.addEventListener('cart:updated', function () { refresh({ force: true }); });
    document.addEventListener('cart:refresh', function () { refresh({ force: true }); });
    document.addEventListener('product:added', function () { refresh({ force: true }); });

    // Also intercept fetch /cart/add so we know when an add succeeded even
    // if the theme dispatches no event.
    if (window.fetch && !window.__gndCartFetchPatched) {
      window.__gndCartFetchPatched = true;
      var origFetch = window.fetch;
      window.fetch = function (input, init) {
        var url = typeof input === 'string' ? input : (input && input.url) || '';
        var p = origFetch.apply(this, arguments);
        if (/\/cart\/(add|change|update|clear)/.test(url)) {
          p.then(function () { refresh({ force: true }); }).catch(function () {});
        }
        return p;
      };
    }
  }

  function init() {
    var root = document.querySelector(SECTION_HOST_SELECTOR + ' ' + ROOT_SELECTOR);
    watchCartForm();
    watchAjaxAdd();
    bindCardInteractions();
    // Initial cache prime + shuffle on the server-rendered pool.
    // Cache stores pre-shuffle innerHTML; shuffle reapplies on every render.
    fetchCart().then(function (cart) {
      if (!cart) return;
      var fp = fingerprint(cart);
      var existing = document.querySelector(SECTION_HOST_SELECTOR);
      if (existing && existing.innerHTML) {
        writeCache(fp, existing.innerHTML);
      }
      if (root) {
        applyDiversityShuffle(root, cart);
        if (root.getAttribute('data-gnd-needs-fallback') === 'true') {
          ensureFallbackChain(root, cart);
        }
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
